import { Controller } from "@hotwired/stimulus"

/**
 * Upload form controller: focuses the product name field when the upload aside is shown.
 */
export default class extends Controller {
  connect() {
    this.focusProductName()
  }

  focusProductName() {
    const field = this.element.querySelector(".product_name")
    if (field) {
      requestAnimationFrame(() => {
        field.focus()
      })
    }
  }
}
